import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 20",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9984 1.47876L12.1017 1.48364C12.6177 1.53379 13.0936 1.95401 13.0938 2.55868V4.7592H15.4342L15.5433 4.76489C16.0867 4.81805 16.584 5.25925 16.5841 5.89038V18.8665L16.5809 18.9454C16.5528 19.2817 16.3467 19.5285 16.1154 19.6575L16.0072 19.7087C15.756 19.8067 15.4331 19.7971 15.1649 19.6143L15.0534 19.5256L8.77002 13.6638L8.74154 13.637L8.71387 13.6638L6.05355 16.1459C5.7852 16.3963 5.43892 16.4494 5.15023 16.3778L5.0306 16.3404C4.74068 16.2267 4.45569 15.9414 4.42106 15.5291L4.41699 15.4452V2.66691C4.41718 1.95778 5.01608 1.47904 5.62956 1.47876H11.9984ZM8.94255 5.55265C8.88803 5.55273 8.83691 5.57037 8.79606 5.59985L8.75863 5.63322L8.72119 5.691C8.70874 5.71834 8.70092 5.74897 8.70085 5.78133V12.5139L8.71224 12.5261L8.76107 12.579L8.79199 12.5489L9.4113 11.9288L9.41211 11.9296L12.2694 9.26522L12.293 9.23104C12.2979 9.21897 12.3003 9.20578 12.3003 9.19279V5.55265H8.94255Z"
    }, null, -1)
  ])))
}
export default { render: render }